module.exports = __webpack_public_path__ + "static/media/tetris-full.1c8ba6cd.png";